import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icons from '../../../../../components/Common/Icons/Icons';
import MenuIcon from '../../../Layout/Menu/MenuIcon';
import { Button } from '../../../../../components/Common/UI/Button';
import Link from '../../../../../components/Common/UI/Link';
import { IPageHeader } from '../index';
import { useMenuContextProvider } from '../../../../context/menu';

function MobilePageHeader({ actions, icon, title }: IPageHeader) {
  const navigate = useNavigate();
  const { toggleMenu } = useMenuContextProvider();

  return (
    <div className="p-[20px] relative bg-secondary flex flex-col gap-[15px] lg:hidden mb-[20px]">
      <div className="flex gap-[20px] justify-between">
        <Icons.HamburgerIcon
          className="[&_path]:fill-white relative cursor-pointer align-top lg:hidden"
          onClick={toggleMenu}
        />
        <Link to="/guidance">
          <Icons.GuidanceMobileLogo className="[&_path]:!fill-[#54C1FB]" />
        </Link>
        <Link to="/guidance/profile">
          <MenuIcon icon={<Icons.User />} variant="header" size="large" />
        </Link>
      </div>
      <div className="relative flex justify-between flex-wrap md:gap-[20px] gap-[15px] md:flex-row flex-col">
        <div className="text-white font-bold text-xl flex gap-[10px] items-center">
          <MenuIcon icon={icon} variant="header" size="large" />
          <div>{title}</div>
        </div>
        <div className="flex gap-[10px] flex-wrap">
          {actions}
          <Button
            variant="outline"
            className="p-[10px_15px] !text-white font-bold !bg-transparent border-white"
            onClick={() => navigate('/guidance/batch-download')}
          >
            Batch Download Documents
          </Button>
        </div>
      </div>
    </div>
  );
}

export default MobilePageHeader;
